import styled from "@emotion/styled";

export const AlertContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
    border-radius: 5px;
    color: ${(props) =>
        props.severity === "warning" ? "#856404" : props.severity === "error" ? "#721c24" : "#155724"};
    background-color: ${(props) =>
        props.severity === "warning" ? "#fff3cd" : props.severity === "error" ? "#f8d7da" : "#d4edda"};
    border: ${(props) =>
        props.severity === "warning"
            ? "1px solid #ffeeba"
            : props.severity === "error"
              ? "1px solid #f5c6cb"
              : "1px solid #c3e6cb"};
`;

export const IconWrapper = styled.div`
    margin-right: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
`;
